var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatalog3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1094 1.58203C10.4951 1.58203 9.92972 1.79379 9.48106 2.14714C9.2509 0.926559 8.17726 0 6.89062 0H2.10938V1.58203H0V18H18V1.58203H11.1094ZM11.1094 2.63672H16.9453V12.7266H11.1094C10.5164 12.7266 9.96831 12.9235 9.52734 13.2551V4.21875C9.52734 3.34644 10.2371 2.63672 11.1094 2.63672ZM9.52734 15.3633C9.52734 14.491 10.2371 13.7812 11.1094 13.7812H16.9453V14.8359H11.1094C10.5163 14.8359 9.96831 15.0327 9.52734 15.3633ZM3.16406 1.05469H6.89062C7.76294 1.05469 8.47266 1.7644 8.47266 2.63672V13.2551C8.03169 12.9235 7.48361 12.7266 6.89062 12.7266H3.16406V1.05469ZM2.10938 2.63672V13.7812H6.89062C7.76294 13.7812 8.47266 14.491 8.47266 15.3633C8.03169 15.0327 7.48375 14.8359 6.89062 14.8359H1.05469V2.63672H2.10938ZM1.05469 15.8906H6.89062C7.57809 15.8906 8.16422 16.3315 8.38202 16.9453H1.05469V15.8906ZM9.61798 16.9453C9.83578 16.3315 10.4219 15.8906 11.1094 15.8906H16.9453V16.9453H9.61798Z",
    fill: "#737A91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8906 3.69141H10.582V11.6719H15.8906V3.69141ZM14.8359 10.6172H11.6367V4.74609H14.8359V10.6172Z",
    fill: "#737A91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41797 2.10938H4.21875V6.36328H7.41797V2.10938ZM6.36328 5.30859H5.27344V3.16406H6.36328V5.30859Z",
    fill: "#737A91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41797 7.41797H4.21875V11.6719H7.41797V7.41797ZM6.36328 10.6172H5.27344V8.47266H6.36328V10.6172Z",
    fill: "#737A91"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalog3);
export default __webpack_public_path__ + "static/media/catalog3.9ac16500.svg";
export { ForwardRef as ReactComponent };